import { create } from "zustand";
const exchangeRates = {};

export const useExchangeRatesStore = create(set => ({
  exchangeRates,
  setExchangeRates: (exchangeRates: any | null) =>
    set((state: any) => ({ exchangeRates })),
  clearExchangeRates: () => set({ exchangeRates })
}));
